import { render } from "./EventsBaseTable.vue?vue&type=template&id=3663c9e9&scoped=true&ts=true"
import script from "./EventsBaseTable.vue?vue&type=script&lang=ts"
export * from "./EventsBaseTable.vue?vue&type=script&lang=ts"

import "./EventsBaseTable.vue?vue&type=style&index=0&id=3663c9e9&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3663c9e9"]])

export default __exports__